
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pos-hardware-partners/imin",
      function () {
        return require("private-next-pages/pos-hardware-partners/imin.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pos-hardware-partners/imin"])
      });
    }
  